/* eslint-disable react/prop-types */
import createReactClass from 'create-react-class';
import _ from 'lodash';
import update from 'react-addons-update';
import { findById as LEGACY_findById } from 'core/utils/legacyUtils';
import urlResolver from 'edrolo/utils/URLResolver';
import * as API from 'edrolo/api';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';
import ExamDataFetcher from 'edrolo/components/exams/ExamDataFetcher';
import ExamSolutionDataFetcher from 'edrolo/components/exams/solutions/ExamSolutionDataFetcher';
import ExamGridWrapper from './ExamGridWrapper';
import StickyTable from './StickyTable';

const ExamGridContainer = createReactClass({
  mixins: [
    ExamDataFetcher, // requires this.props.baseUrl
    ExamSolutionDataFetcher, // requires this.props.data.solution_data_url
    StickyTable,
  ],

  displayName: 'ExamGridContainer',

  getInitialState() {
    return {
      sittingData: [],
      sittingLoaded: false,
      sittingLoadedForExam: null,
      fetchingSittingData: false,
      classData: {
        enrolments: [],
        students: [],
      },
      classLoaded: false,
      fetchingClassData: false,
      deletingExamSitting: false,
    };
  },

  componentDidMount() {
    analytics.track('viewed exam grid', {
      class_id: this.props.classId,
      exam_id: this.props.examId,
    });

    this.reload();
  },

  componentDidUpdate(prevProps) {
    if (prevProps.examId !== this.props.examId) {
      this.reload();
    }
  },

  dataIsReady() {
    const state = this.state;

    return (
      !state.fetchingSittingData &&
      !state.deletingExamSitting &&
      state.examData.id &&
      state.classLoaded &&
      state.sittingLoadedForExam &&
      state.solutionLoadedForExam
    );
  },

  fetchSchoolClassExamSittingData(onSuccess) {
    const { examId, classId } = this.props;

    if (this.state.fetchingSittingData) {
      return;
    }
    this.setState({
      fetchingSittingData: true,
    });

    const url = urlResolver.reverse('api:class-exam-sitting-list', {
      classId: classId,
      examId: examId,
    });

    $.ajax({
      url,
      dataType: 'json',
      success: function (newSittingData) {
        this.setState(
          {
            sittingData: newSittingData.sittings,
            sittingLoaded: true,
            sittingLoadedForExam: examId,
            fetchingSittingData: false,
          },
          onSuccess
        );
      }.bind(this),
      error: function (xhr, status, err) {
        // eslint-disable-next-line no-console
        console.error(url, status, err.toString());
        this.setState({
          fetchingSittingData: false,
        });
      }.bind(this),
    });
  },

  updateSittingData(responseData) {
    const sitting = LEGACY_findById(
      this.state.sittingData,
      responseData.responder,
      'profile'
    );
    const sittingIndex = this.state.sittingData.indexOf(sitting);

    // Sometimes question id is a string - TODO force api to return int from /feedback/
    // eslint-disable-next-line no-param-reassign
    responseData.question = parseInt(responseData.question, 10);

    // Add/Update the new response data
    if (!_.isUndefined(sitting.responses)) {
      // Remove the old response
      _.remove(sitting.responses, { id: responseData.id });
      // Add the new response
      sitting.responses.push(responseData);
    }

    const newSittingData = update(this.state.sittingData, {
      $splice: [[sittingIndex, 1, sitting]],
    });
    this.setState({ sittingData: newSittingData });
  },

  fetchSchoolClassData(onSuccess) {
    if (this.state.fetchingClassData) {
      return;
    }
    this.setState({
      fetchingClassData: true,
    });

    const url = urlResolver.reverse('api:class-detail', {
      classId: this.props.classId,
    });

    $.ajax({
      url,
      dataType: 'json',
      success: function (newClassData) {
        // eslint-disable-next-line no-param-reassign
        newClassData.students = newClassData.enrolments.map(
          (enrolment) => enrolment.profile
        );

        this.setState(
          {
            classData: newClassData,
            classLoaded: true,
            fetchingClassData: false,
          },
          onSuccess
        );
      }.bind(this),
      error: function (xhr, status, err) {
        // eslint-disable-next-line no-console
        console.error(url, status, err.toString());
        this.setState({
          fetchingClassData: false,
        });
      }.bind(this),
    });
  },

  reload() {
    this.fetchExamData(this.props.examId);
    this.fetchSchoolClassData();
    this.fetchSchoolClassExamSittingData();
    this.fetchSolutionData(this.props.examId);
  },

  async deleteExamSitting(examId, sittingId) {
    this.setState({ deletingExamSitting: true });
    const { classId } = this.props;
    // TODO: error handling?
    await API.deleteExamSitting(classId, examId, sittingId);
    this.reload();
    this.setState({ deletingExamSitting: false });

    analytics.track('deleted exam sitting', {
      origin: 'exam_grid',
      class_id: classId,
      exam_id: examId,
      sitting_id: sittingId,
    });
  },

  handleChangedResponse(responseData) {
    this.updateSittingData(responseData);
  },

  render() {
    if (!this.dataIsReady()) {
      return (
        <div className="exam-grid" id="exam-grid">
          <LoadingIndicator loadingText="Loading Results" />
        </div>
      );
    }

    const {
      examData,
      sittingData,
      classData,
      solutionData = { questions: [] },
    } = this.state;
    const { isAnonymized, isStaff } = this.props;

    return (
      <ExamGridWrapper
        deleteExamSitting={this.deleteExamSitting}
        examData={examData}
        sittingData={sittingData}
        classData={classData}
        solutionData={solutionData}
        onChangedResponse={this.handleChangedResponse}
        isAnonymized={isAnonymized}
        isStaff={isStaff}
        highlightProfileId={this.props.highlightProfileId}
      />
    );
  },
});

export default ExamGridContainer;
